export default __webpack_public_path__ + "static/media/Login_Signup-01.07ad5414.svg";